import { GameType } from '@hit-game/shared/enums';

export const GAME_LABELS: Record<GameType, string> = {
  [GameType.TX]: 'Tài Xỉu',
  [GameType.XD]: 'Xóc Đĩa',
  [GameType.XDMD5]: 'Xóc Đĩa MD5',
  [GameType.BAUCUA]: 'Bầu Cua',
};

export const GAME_BADGES: Record<GameType, string> = {
  [GameType.TX]: 'bg-accent/20 text-accent',
  [GameType.XD]: 'bg-action-violet/20 text-action-violet',
  [GameType.XDMD5]: 'bg-warning/20 text-warning',
  [GameType.BAUCUA]: 'bg-success/20 text-success',
};

export const GAME_OPTIONS = Object.values(GameType).map((value) => ({
  value,
  label: GAME_LABELS[value],
}));

/** Màu gán theo thứ tự thành viên — dùng chung với thẻ nhóm ngoài sảnh. */
export const MEMBER_COLORS = ['#3b82f6', '#f59e0b', '#a855f7', '#14b8a6', '#ef4444', '#22c55e'];
